import {
  ICurrentUserReduxState,
  IFetchAuthTokenRejected,
  IGetCurretUserAction,
  IGetCurretUserActionFulfilled,
  IGetCurretUserActionRejected,
  IGetMyOpenTasksCount,
  IGetMyOpenTasksCountFulfilled
} from "../../types";

const initialState: ICurrentUserReduxState = {
  authFailed: false,
  openTasks: {
    completed: false,
    myEmployeesCount: 0,
    myFeedbacksCount: 0,
    anonymousCount: 0,
    peersCount: 0
  },
  userData: {
    id: "",
    firstName: "",
    lastName: "",
    middleName: "",
    photoBase64: "",
    email: "string",
    userRole: "USER"
  },
  userDataCompleted: false,
  userDataPending: false
};

type Actions =
  | IFetchAuthTokenRejected
  | IGetCurretUserAction
  | IGetCurretUserActionFulfilled
  | IGetCurretUserActionRejected
  | IGetMyOpenTasksCount
  | IGetMyOpenTasksCountFulfilled;

export default (state = initialState, action: Actions) => {
  switch (action.type) {
    case "GET_CURRENT_USER":
      return {
        ...state,
        userDataCompleted: false,
        userDataPending: true
      };
    case "GET_CURRENT_USER_FULFILLED":
      return {
        ...state,
        authFailed: false,
        userData: action.payload,
        userDataCompleted: true,
        userDataPending: false
      };
    case "FETCH_AUTH_TOKEN_REJECTED":
      return {
        ...state,
        authFailed: true
      };
    case "GET_MY_OPEN_TASKS_FULFILLED":
      return {
        ...state,
        openTasks: {
          ...action.payload,
          completed: true
        }
      };
    default:
      return state;
  }
};
